import { useLanguage } from '../../contexts/language';

import styles from './style.module.css';

// The next appointment: a date tile, the day and time by the device's clock,
// its length, format and clinician, and how many of the questionnaires due
// before it are submitted. The count is left out when nothing is due.
export function NextAppointment({ appointment }) {
  const { text, language } = useLanguage();
  const { startsAt, durationMinutes, format, clinician, questionnaires } = appointment;
  const at = new Date(startsAt);
  const day = new Intl.DateTimeFormat(language, { weekday: 'short', day: 'numeric', month: 'short' }).format(at);
  const time = new Intl.DateTimeFormat(language, { hour: '2-digit', minute: '2-digit' }).format(at);
  const month = new Intl.DateTimeFormat(language, { month: 'short' }).format(at);
  const details = [ text.minutes.replace('{minutes}', durationMinutes), text.formats[ format ], clinician ];

  let count = null;

  if (questionnaires.total > 0) {
    count = (
      <div className={ styles.row }>
        <span className={ styles.before }>{ text.questionnairesBefore }</span>
        <span className={ styles.count }>{ text.submittedOf.replace('{submitted}', questionnaires.submitted).replace('{total}', questionnaires.total) }</span>
      </div>
    );
  }

  return (
    <div className={ styles.pane }>
      <h2 className={ styles.label }>{ text.nextAppointment }</h2>

      <div className={ styles.when }>
        <span className={ styles.tile } aria-hidden='true'>
          <span className={ styles.month }>{ month }</span>
          <span className={ styles.number }>{ at.getDate() }</span>
        </span>

        <span className={ styles.lines }>
          <span className={ styles.time }>{ `${ day } · ${ time }` }</span>
          <span className={ styles.details }>{ details.join(' · ') }</span>
        </span>
      </div>

      { count }
    </div>
  );
}
